import React from 'react';
import { isOverflowNode, type SearchAttackPathNode } from './types';
import { Image } from '@plerionhq/design-system';

import { useTranslation } from 'react-i18next';

const modifierNodesLabel: Record<string, string> = {
  'Public exposure':
    'This group represents assets contributing to public exposure',
  'Sensitive data':
    'This group represents the sensitive information accessible by the workload',
  'Resource access':
    'This group represents the AWS resources accessible by the workload',
};

export const AssetHeader = ({ node }: { node: SearchAttackPathNode }) => {
  const { t } = useTranslation('pleri/chat');
  const isModifierGroup = node.graphProps?.assetType === 'modifier-group';

  if (isOverflowNode(node)) {
    const hiddenCount = node.meta?.hiddenCount ?? 0;
    return (
      <div className="flex flex-col gap-3">
        <div className="text-sm text-gray-700 dark:text-gray-300">
          {t('moreResources', { count: hiddenCount })}
        </div>
        <div className="text-xs text-gray-500 dark:text-gray-400">
          {t('onlyTheFirstFewAreDrawnSo')}
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3">
      <div>
        <div className="mb-2 text-sm font-medium text-gray-600 dark:text-gray-400">
          {t('resource')}
        </div>
        <div className="flex gap-4">
          {!isModifierGroup && (
            <div>
              <Image
                type="resourceType"
                name={node.data?.type}
                fallback={{
                  type: 'provider',
                  name: 'AWS',
                }}
                className="h-8 w-8 flex-shrink-0 rounded-md object-contain"
              />
            </div>
          )}
          <div className="flex flex-col">
            <div className="text-sm text-gray-700 dark:text-gray-300">
              {node.graphProps?.name}
            </div>
            <div className="text-xs text-gray-500 dark:text-gray-400">
              {isModifierGroup ? t('common:group') : node.data?.type}
            </div>
          </div>
        </div>
      </div>
      {isModifierGroup && (
        <div>
          <div className="text-sm text-gray-700 dark:text-gray-300">
            {modifierNodesLabel[node.subLabel ?? ''] ?? ''}
          </div>
        </div>
      )}
    </div>
  );
};
